<template>
  <div calss="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('activity_reports') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_activity_report')"
        :loading="savingActivityReport"
        :saving="savingActivityReport"
        @click="initActivityReport"
      />
    </div>

    <BaseTableLoader :loading="!activityReports">
      <ActivityReportsTable
        :items="activityReports"
        :pagination="activityReportsPagination"
        :loading="loadingActivityReports"
        @update:page="onPageChange"
        @edit="$router.push({ name: 'editActivityReport', params: { id: $event.id } })"
        @delete="deleteActivityReport"
      />
    </BaseTableLoader>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import BaseTableLoader from '../../components/base/BaseTableLoader';
import ActivityReportsTable from '../../components/ActivityReportsTable';

export default {
  name: 'ActivityReports',

  components: { ActivityReportsTable, BaseTableLoader, BasePrimaryActionButton },

  created() {
    if (!this.activityReports) {
      this.fetchActivityReports(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.activityReportsFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'activityReports'
    ) {
      this.fetchActivityReports(to.query);
    }
    next();
  },

  computed: mapState('activityReports', [
    'activityReports',
    'activityReportsPagination',
    'activityReportsFilterParams',
    'loadingActivityReports',
    'savingActivityReport',
  ]),

  methods: {
    ...mapActions('activityReports', [
      'fetchActivityReports',
      'storeActivityReport',
      'deleteActivityReport',
    ]),

    initActivityReport() {
      this.storeActivityReport().then((res) => {
        this.$router.push({ name: 'editActivityReport', params: { id: res.data.id } });
      });
    },

    onPageChange(page) {
      const query = { ...this.activityReportsFilterParams, page };
      this.$router.push({ name: 'activityReports', query });
    },
  },
};
</script>

<style scoped></style>
